import * as React from 'react';
import { createSubcomponent, getTheme, styled, } from '@workday/canvas-kit-react/common';
import { Popup } from '@workday/canvas-kit-react/popup';
import { space } from '@workday/canvas-kit-react/tokens';
import { useModalModel } from './hooks';
const ResponsiveModalBody = styled(Popup.Body)(({ theme }) => {
    const { canvas: canvasTheme } = getTheme(theme);
    return {
        [canvasTheme.breakpoints.down('s')]: {
            marginBottom: space.zero,
            padding: `${space.xxxs} ${space.xxs} ${space.xxs} ${space.xxs}`,
        },
    };
});
export const ModalBody = createSubcomponent('div')({
    displayName: 'Modal.Body',
    modelHook: useModalModel,
})((elemProps, Element) => {
    return React.createElement(ResponsiveModalBody, Object.assign({ as: Element }, elemProps));
});
